import { UserNameInlineEditor } from 'components/inline_edit/UserNameInlineEditor';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';

export function UserNameCell({
    rowData,
    url,
    onChange,
}: UsersTableCellProps & { url: string }) {
    return (
        <UserNameInlineEditor
            userId={rowData.Id}
            firstName={rowData.FirstName}
            lastName={rowData.LastName}
            onChange={onChange}
            containerSizing="expand"
            url={url}
        />
    );
}
